(function () {
  'use strict';

  if (window.__smCartRecommendationsInitialized) return;
  window.__smCartRecommendationsInitialized = true;

  var mountSelector = '[data-sm-cart-recommendations-mount]';
  var refreshTimer;
  var pendingTimer;
  var requestNumber = 0;
  var candidateLimit = 4;
  var visibleProductLimit = 2;
  var sourceProductLimit = 4;
  var recommendationIntents = [
    { intent: 'complementary', label: 'COMPLETE THE LOOK' }
  ];

  var state = {
    anchorProductId: null,
    preferredAnchorProductId: null,
    pendingCandidateProductId: null,
    pendingCandidateSourceProductId: null,
    pendingCandidateProductTitle: null,
    pendingCandidateIntent: null,
    pendingCandidatePosition: null,
    previousCart: null,
    renderedKey: null,
    drawerWasOpen: false,
    activeIntent: 'complementary',
    viewedRecommendationKeys: {}
  };

  function getMount() {
    return document.querySelector(mountSelector);
  }

  function getRootUrl() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  function getCart() {
    return fetch(getRootUrl() + 'cart.js', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to read cart');
      return response.json();
    });
  }

  function productId(value) {
    return value === undefined || value === null ? null : String(value);
  }

  function cartContainsProduct(cart, targetProductId) {
    var target = productId(targetProductId);
    if (!target || !cart || !cart.items) return false;

    return cart.items.some(function (item) {
      return productId(item.product_id) === target;
    });
  }

  function productQuantities(cart) {
    var quantities = {};
    if (!cart || !cart.items) return quantities;

    cart.items.forEach(function (item) {
      var id = productId(item.product_id);
      if (!id) return;
      quantities[id] = (quantities[id] || 0) + Number(item.quantity || 0);
    });

    return quantities;
  }

  function detectAddedProduct(previousCart, currentCart) {
    if (!previousCart || !currentCart || !currentCart.items) return null;

    var previous = productQuantities(previousCart);
    var addedProductId = null;
    var largestIncrease = 0;

    currentCart.items.forEach(function (item) {
      var id = productId(item.product_id);
      var increase = Number(item.quantity || 0) - Number(previous[id] || 0);

      if (increase > largestIncrease) {
        largestIncrease = increase;
        addedProductId = id;
      }
    });

    return addedProductId;
  }

  function firstCartProductId(cart) {
    if (!cart || !cart.items || !cart.items.length) return null;
    return productId(cart.items[0].product_id);
  }

  function chooseAnchor(cart, keepExistingAnchor) {
    var preferred = productId(state.preferredAnchorProductId);
    state.preferredAnchorProductId = null;

    if (preferred && cartContainsProduct(cart, preferred)) {
      return preferred;
    }

    if (
      keepExistingAnchor &&
      state.anchorProductId &&
      cartContainsProduct(cart, state.anchorProductId)
    ) {
      return state.anchorProductId;
    }

    var detected = detectAddedProduct(state.previousCart, cart);
    if (detected) return detected;

    if (state.anchorProductId && cartContainsProduct(cart, state.anchorProductId)) {
      return state.anchorProductId;
    }

    return firstCartProductId(cart);
  }

  // Anchor first, then the other cart products in cart.items order (newest first).
  function sourceProductIds(anchorProductId, cart) {
    var sources = [];
    var seen = {};
    var anchor = productId(anchorProductId);

    if (anchor) {
      sources.push(anchor);
      seen[anchor] = true;
    }

    if (cart && cart.items) {
      cart.items.forEach(function (item) {
        if (sources.length >= sourceProductLimit) return;
        if (item.gift_card === true) return;

        var id = productId(item.product_id);
        if (!id || seen[id]) return;

        seen[id] = true;
        sources.push(id);
      });
    }

    return sources.slice(0, sourceProductLimit);
  }

  function cartSignature(cart) {
    if (!cart || !cart.items) return 'empty';

    return cart.items
      .map(function (item) {
        return String(item.key || item.variant_id) + ':' + String(item.quantity || 0);
      })
      .sort()
      .join('|');
  }

  function recommendationUrl(anchorProductId, intent) {
    var params = [
      'section_id=cart-drawer-recommendations',
      'product_id=' + encodeURIComponent(anchorProductId),
      'limit=' + String(candidateLimit),
      'intent=' + encodeURIComponent(intent)
    ];

    return getRootUrl() + 'recommendations/products?' + params.join('&');
  }

  function clearMount() {
    var mount = getMount();
    if (!mount) return;

    mount.innerHTML = '';
    mount.hidden = true;
    mount.removeAttribute('aria-busy');
    mount.removeAttribute('data-cart-line-count');
    state.renderedKey = null;
  }

  function dataLayerEvent(name, values) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, values || {}));
  }

  function cardSourceProductId(card) {
    return productId(card.dataset.sourceProductId) || productId(state.anchorProductId);
  }

  function recommendationSource(sourceProductId) {
    return productId(sourceProductId) === productId(state.anchorProductId) ? 'anchor' : 'fallback';
  }

  function activeRecommendationCards() {
    var mount = getMount();
    if (!mount) return [];

    var activePanel = mount.querySelector(
      '[data-sm-cart-recommendations-panel]:not([hidden])'
    );
    var scope = activePanel || mount;

    return Array.prototype.slice.call(
      scope.querySelectorAll('[data-sm-cart-recommendation-product]')
    );
  }

  function recordVisibleViews() {
    if (!isDrawerOpen()) return;

    activeRecommendationCards().forEach(function (card, index) {
      var recommendationId = productId(card.dataset.productId);
      var sourceId = cardSourceProductId(card);
      var intent = card.dataset.recommendationIntent || '';
      var viewKey = sourceId + '|' + intent + '|' + recommendationId;

      if (!recommendationId || state.viewedRecommendationKeys[viewKey]) return;

      dataLayerEvent('cart_cross_sell_view', {
        anchor_product_id: sourceId,
        recommendation_source: recommendationSource(sourceId),
        recommended_product_id: recommendationId,
        recommended_product_title: card.dataset.productTitle || '',
        recommendation_intent: intent,
        recommendation_position: index + 1
      });

      state.viewedRecommendationKeys[viewKey] = true;
    });
  }

  function fetchRecommendationResult(sourceProductId, config) {
    return fetch(recommendationUrl(sourceProductId, config.intent), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to load ' + config.intent + ' recommendations');
        return response.text();
      })
      .then(function (text) {
        var temporary = document.createElement('div');
        temporary.innerHTML = text;
        var result = temporary.querySelector('[data-sm-cart-recommendations-result]');
        var cards = result
          ? Array.prototype.slice.call(
              result.querySelectorAll('[data-sm-cart-recommendation-product]')
            )
          : [];

        cards.forEach(function (card) {
          card.dataset.sourceProductId = String(sourceProductId);
        });

        return {
          intent: config.intent,
          label: config.label,
          sourceProductId: productId(sourceProductId),
          cards: cards
        };
      })
      .catch(function () {
        return {
          intent: config.intent,
          label: config.label,
          sourceProductId: productId(sourceProductId),
          cards: []
        };
      });
  }

  // Results arrive as one entry per source product per intent, already in
  // intent order then source order, so concatenating gives an anchor-first pool.
  function eligibleResults(results, cart) {
    var seenProductIds = {};
    var byIntent = {};
    var pools = [];

    results.forEach(function (result) {
      var pool = byIntent[result.intent];

      if (!pool) {
        pool = { intent: result.intent, label: result.label, cards: [] };
        byIntent[result.intent] = pool;
        pools.push(pool);
      }

      pool.cards = pool.cards.concat(result.cards);
    });

    return pools
      .map(function (pool) {
        pool.cards = pool.cards
          .filter(function (card) {
            var id = productId(card.dataset.productId);
            if (!id || seenProductIds[id]) return false;
            if (cartContainsProduct(cart, id)) return false;
            seenProductIds[id] = true;
            return true;
          })
          .slice(0, visibleProductLimit);

        return pool;
      })
      .filter(function (pool) {
        return pool.cards.length > 0;
      });
  }

  function buildTabbedSection(results) {
    if (!results.length) return null;

    var section = document.createElement('section');
    var tabList = document.createElement('div');
    var panels = document.createElement('div');
    var activeIndex = results.findIndex(function (result) {
      return result.intent === state.activeIntent;
    });

    if (activeIndex < 0) activeIndex = 0;
    state.activeIntent = results[activeIndex].intent;

    section.className = 'sm-cart-recommendations';
    section.setAttribute('data-sm-cart-recommendations-content', '');
    section.setAttribute('aria-label', 'Cart product recommendations');

    tabList.className = 'sm-cart-recommendations__tabs';
    tabList.setAttribute('role', 'tablist');
    tabList.setAttribute('aria-label', 'Recommendation type');

    panels.className = 'sm-cart-recommendations__panels';

    results.forEach(function (result, resultIndex) {
      var selected = resultIndex === activeIndex;
      var tabId = 'SMCartRecommendationsTab-' + result.intent;
      var panelId = 'SMCartRecommendationsPanel-' + result.intent;
      var tab = document.createElement('button');
      var panel = document.createElement('div');
      var products = document.createElement('div');

      tab.type = 'button';
      tab.id = tabId;
      tab.className = 'sm-cart-recommendations__tab';
      tab.textContent = result.label;
      tab.dataset.recommendationIntent = result.intent;
      tab.dataset.recommendationPanel = panelId;
      tab.setAttribute('data-sm-cart-recommendations-tab', '');
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-controls', panelId);
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      tab.tabIndex = selected ? 0 : -1;

      panel.id = panelId;
      panel.className = 'sm-cart-recommendations__panel';
      panel.dataset.recommendationIntent = result.intent;
      panel.setAttribute('data-sm-cart-recommendations-panel', '');
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', tabId);
      panel.hidden = !selected;

      products.className = 'sm-cart-recommendations__products';

      result.cards.forEach(function (card, cardIndex) {
        card.dataset.recommendationIntent = result.intent;
        card.dataset.recommendationPosition = String(cardIndex + 1);
        products.appendChild(card);
      });

      panel.appendChild(products);
      tabList.appendChild(tab);
      panels.appendChild(panel);
    });

    section.appendChild(tabList);
    section.appendChild(panels);

    return section;
  }

  function activateTab(tab, focusTab) {
    var mount = getMount();
    if (!mount || !tab || !mount.contains(tab)) return;

    var panelId = tab.dataset.recommendationPanel;
    var intent = tab.dataset.recommendationIntent || '';
    var tabs = mount.querySelectorAll('[data-sm-cart-recommendations-tab]');
    var panels = mount.querySelectorAll('[data-sm-cart-recommendations-panel]');

    Array.prototype.forEach.call(tabs, function (item) {
      var selected = item === tab;
      item.setAttribute('aria-selected', selected ? 'true' : 'false');
      item.tabIndex = selected ? 0 : -1;
    });

    Array.prototype.forEach.call(panels, function (panel) {
      panel.hidden = panel.id !== panelId;
    });

    state.activeIntent = intent;

    if (focusTab) tab.focus();

    dataLayerEvent('cart_cross_sell_tab_change', {
      anchor_product_id: productId(state.anchorProductId),
      recommendation_intent: intent
    });

    recordVisibleViews();
  }

  function renderRecommendations(anchorProductId, cart) {
    var mount = getMount();
    if (!mount || !anchorProductId) {
      clearMount();
      return Promise.resolve();
    }

    mount.dataset.cartLineCount = String(cart && cart.items ? cart.items.length : 0);

    var renderKey = productId(anchorProductId) + '|' + cartSignature(cart);
    if (renderKey === state.renderedKey) {
      recordVisibleViews();
      return Promise.resolve();
    }

    var thisRequest = ++requestNumber;
    var sources = sourceProductIds(anchorProductId, cart);
    var requests = [];

    recommendationIntents.forEach(function (config) {
      sources.forEach(function (sourceProductId) {
        requests.push({ sourceProductId: sourceProductId, config: config });
      });
    });

    mount.setAttribute('aria-busy', 'true');

    return Promise.all(
      requests.map(function (request) {
        return fetchRecommendationResult(request.sourceProductId, request.config);
      })
    ).then(function (results) {
      if (thisRequest !== requestNumber) return;

      var section = buildTabbedSection(eligibleResults(results, cart));

      mount.innerHTML = '';
      mount.removeAttribute('aria-busy');
      state.renderedKey = renderKey;

      if (!section) {
        mount.hidden = true;
        return;
      }

      mount.appendChild(section);
      mount.hidden = false;
      recordVisibleViews();
    });
  }

  function sync() {
    if (!getMount()) return;

    getCart()
      .then(function (cart) {
        if (!cart.items || !cart.items.length) {
          state.anchorProductId = null;
          state.pendingCandidateProductId = null;
          state.pendingCandidateSourceProductId = null;
          state.pendingCandidateProductTitle = null;
          state.pendingCandidateIntent = null;
          state.pendingCandidatePosition = null;
          state.previousCart = cart;
          clearMount();
          return;
        }

        var keepExistingAnchor = false;
        var pendingCandidate = productId(state.pendingCandidateProductId);

        if (pendingCandidate && cartContainsProduct(cart, pendingCandidate)) {
          var pendingSource =
            productId(state.pendingCandidateSourceProductId) || productId(state.anchorProductId);

          dataLayerEvent('cart_cross_sell_add', {
            anchor_product_id: pendingSource,
            recommendation_source: recommendationSource(pendingSource),
            recommended_product_id: pendingCandidate,
            recommended_product_title: state.pendingCandidateProductTitle || '',
            recommendation_intent: state.pendingCandidateIntent || '',
            recommendation_position: state.pendingCandidatePosition
          });

          state.pendingCandidateProductId = null;
          state.pendingCandidateSourceProductId = null;
          state.pendingCandidateProductTitle = null;
          state.pendingCandidateIntent = null;
          state.pendingCandidatePosition = null;
          clearTimeout(pendingTimer);
          keepExistingAnchor = true;
        }

        state.anchorProductId = chooseAnchor(cart, keepExistingAnchor);
        state.previousCart = cart;

        return renderRecommendations(state.anchorProductId, cart);
      })
      .catch(function () {
        clearMount();
      });
  }

  function scheduleSync(preferredAnchorProductId, delay) {
    if (preferredAnchorProductId) {
      state.preferredAnchorProductId = productId(preferredAnchorProductId);
    }

    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(sync, delay === undefined ? 180 : delay);
  }

  function isDrawerOpen() {
    var html = document.documentElement;
    var drawer = document.getElementById('CartDrawer');

    if (html.classList.contains('js-drawer-open-right')) return true;
    if (!drawer) return false;

    return (
      drawer.classList.contains('is-open') ||
      drawer.classList.contains('drawer--is-open') ||
      drawer.classList.contains('active')
    );
  }

  function drawerStateChanged() {
    var open = isDrawerOpen();

    if (open && !state.drawerWasOpen) {
      state.viewedRecommendationKeys = {};
      recordVisibleViews();
    }

    if (!open && state.drawerWasOpen) {
      state.viewedRecommendationKeys = {};
    }

    state.drawerWasOpen = open;
  }

  function productIdFromAjaxEvent(event) {
    if (!event || !event.detail || !event.detail.product) return null;

    return productId(
      event.detail.product.product_id ||
      event.detail.product.productId ||
      event.detail.product.id
    );
  }

  function init() {
    var mount = getMount();
    if (!mount) return;

    state.drawerWasOpen = isDrawerOpen();

    document.addEventListener(
      'click',
      function (event) {
        var tab = event.target.closest('[data-sm-cart-recommendations-tab]');
        if (tab && mount.contains(tab)) {
          activateTab(tab, false);
          return;
        }

        var card = event.target.closest('[data-sm-cart-recommendation-product]');
        if (!card || !mount.contains(card)) return;

        var actionButton = event.target.closest('.qai-trigger');
        var productLink = event.target.closest('a');
        var cardSourceId = cardSourceProductId(card);

        if (actionButton) {
          state.pendingCandidateProductId = productId(card.dataset.productId);
          state.pendingCandidateSourceProductId = cardSourceId;
          state.pendingCandidateProductTitle = card.dataset.productTitle || '';
          state.pendingCandidateIntent = card.dataset.recommendationIntent || '';
          state.pendingCandidatePosition = Number(card.dataset.recommendationPosition || 0);
          clearTimeout(pendingTimer);
          pendingTimer = setTimeout(function () {
            state.pendingCandidateProductId = null;
            state.pendingCandidateSourceProductId = null;
            state.pendingCandidateProductTitle = null;
            state.pendingCandidateIntent = null;
            state.pendingCandidatePosition = null;
          }, 10000);

          dataLayerEvent('cart_cross_sell_click', {
            anchor_product_id: cardSourceId,
            recommendation_source: recommendationSource(cardSourceId),
            recommended_product_id: productId(card.dataset.productId),
            recommended_product_title: card.dataset.productTitle || '',
            recommendation_intent: card.dataset.recommendationIntent || '',
            recommendation_position: Number(card.dataset.recommendationPosition || 0),
            action: actionButton.dataset.qaiAction === 'picker' ? 'choose_options' : 'add'
          });
        } else if (productLink) {
          dataLayerEvent('cart_cross_sell_click', {
            anchor_product_id: cardSourceId,
            recommendation_source: recommendationSource(cardSourceId),
            recommended_product_id: productId(card.dataset.productId),
            recommended_product_title: card.dataset.productTitle || '',
            recommendation_intent: card.dataset.recommendationIntent || '',
            recommendation_position: Number(card.dataset.recommendationPosition || 0),
            action: 'view_product'
          });
        }
      },
      true
    );

    document.addEventListener('keydown', function (event) {
      var tab = event.target.closest('[data-sm-cart-recommendations-tab]');
      if (!tab || !mount.contains(tab)) return;
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

      var tabs = Array.prototype.slice.call(
        mount.querySelectorAll('[data-sm-cart-recommendations-tab]')
      );
      var currentIndex = tabs.indexOf(tab);
      var direction = event.key === 'ArrowRight' ? 1 : -1;
      var nextIndex = (currentIndex + direction + tabs.length) % tabs.length;

      event.preventDefault();
      activateTab(tabs[nextIndex], true);
    });

    document.addEventListener('ajaxProduct:added', function (event) {
      var preferred = null;

      if (!state.pendingCandidateProductId) {
        preferred = productIdFromAjaxEvent(event);
      }

      scheduleSync(preferred, 240);
    });

    document.addEventListener('cart:updated', function () {
      scheduleSync(null, 220);
    });

    document.addEventListener('cart:refresh', function () {
      scheduleSync(null, 220);
    });

    var classObserver = new MutationObserver(drawerStateChanged);
    classObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class']
    });

    var drawer = document.getElementById('CartDrawer');
    if (drawer) {
      classObserver.observe(drawer, {
        attributes: true,
        attributeFilter: ['class']
      });
    }

    window.SMCartDrawerRecommendations = {
      refresh: function () {
        state.renderedKey = null;
        scheduleSync(null, 0);
      },
      state: state
    };

    scheduleSync(null, 0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
